<template>
  <div class="tab-bar-layout">
    <guide-popup />
    <slot></slot>
    <copyright />
  </div>
</template>

<script>
  import GuidePopup from '@/components/LearningModulefGuidePopup';
  import Copyright from '@/components/Copyright';

  export default {
    name: 'TabBarLayout',
    components: {
      GuidePopup,
      Copyright,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .tab-bar-layout {
    min-height: 100%;
    padding-bottom: @tabbar-height;
  }
</style>
